dmx.Component('browser', {

    initialData: {
        online: navigator.onLine,
        doNotTrack: false,
        userAgent: navigator.userAgent,
        language: navigator.language,
        cookieEnabled: navigator.cookieEnabled,
        referrer: document.referrer,

        location: {
            hash: window.location.hash,
            host: window.location.host,
            hostname: window.location.hostname,
            href: window.location.href,
            origin: window.location.origin,
            pathname: window.location.pathname,
            port: window.location.port,
            protocol: window.location.protocol,
            search: window.location.search,
            pathparts: window.location.pathname.substr(1).split('/')
        },

        scrollX: {
            offset: 0,
            direction: 0,
            position: 0
        },

        scrollY: {
            offset: 0,
            direction: 0,
            position: 0
        },

        viewport: {
            width: 0,
            height: 0
        },

        device: {
            width: 0,
            height: 0,
            pixelRatio: 1,
            orientation: 'landscape'
        },

        document: {
            width: 0,
            height: 0,
            hidden: document.hidden,
            visibility: document.visibilityState
        }
    },

    methods: {
        goto: function(url, internal, title) {
            if (url[0] == '.' && url[1] == '/') {
                var base = document.querySelector('meta[name="ac:base"]');
                var route = document.querySelector('meta[name="ac:route"]');

                if (route && route.content) {
                    var path = route.content;

                    if (base && base.content) {
                        path = base.content.replace(/\/$/, '') + path;
                    }

                    var match = dmx.pathToRegexp(path, [], { end: false }).exec(location.pathname);

                    if (match) {
                        window.history.pushState({ title: title }, '', url.replace('./', match[0]));
                        if (title) document.title = title;
                        dmx.requestUpdate();

                        window.dispatchEvent(new Event('pushstate'));
                        return;
                    }
                }
            }

            if (internal) {
                window.history.pushState({ title: title || document.title }, '', url);
                if (title) document.title = title;
                dmx.requestUpdate();

                window.dispatchEvent(new Event('pushstate'));
                return;
            }

            window.location = url;
        },

        scrollTo: function(x, y) {
            window.scrollTo(x, y);
        },

        scrollXTo: function(pos) {
            window.scrollTo({ left: pos });
        },

        scrollYTo: function(pos) {
            window.scrollTo({ top: pos });
        },

        scrollBy: function(x, y) {
            window.scrollBy(x, y);
        },

        scrollXBy: function(delta) {
            window.scrollBy({ left: delta });
        },

        scrollYBy: function(delta) {
            window.scrollBy({ top: delta });
        },

        alert: function(message) {
            window.alert(message);
        },

        copy: function() {
            document.execCommand('copy');
        },

        cut: function() {
            document.execCommand('cut');
        },

        paste: function() {
            document.execCommand('paste');
        },

        delete: function() {
            document.execCommand('delete');
        },

        selectAll: function() {
            document.execCommand('selectAll');
        },

        writeTextToClipboard: function(text) {
            return navigator.clipboard.writeText(text);
        }
    },

    events: {
        scroll: Event,
        resize: Event,
        online: Event,
        offline: Event,
        popstate: Event,
        visibilitychange: Event,
        orientationchange: Event
    },

    render: function(node) {
        window.addEventListener('scroll', dmx.throttle(this._update.bind(this)));
        window.addEventListener('resize', dmx.throttle(this._update.bind(this)));
        window.addEventListener('online', this._update.bind(this));
        window.addEventListener('offline', this._update.bind(this));
        window.addEventListener('popstate', this._update.bind(this));
        window.addEventListener('pushstate', this._update.bind(this));
        window.addEventListener('replacestate', this._update.bind(this));
        window.addEventListener('hashchange', this._update.bind(this));
        window.addEventListener('visibilitychange', this._update.bind(this));
        if (window.orientation) window.addEventListener('orientationchange', this._update.bind(this));
        this._update();
    },

    _update: function(event) {
        var docWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth);
        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

        var scrollDirectionX = this.data.scrollX.direction;
        var scrollDirectionY = this.data.scrollY.direction;

        if (event && event.type == 'scroll') {
            if (this.data.scrollX.offset < window.pageXOffset) {
                scrollDirectionX = 1;
            } else if (this.data.scrollX.offset > window.pageXOffset) {
                scrollDirectionX = -1;
            }

            if (this.data.scrollY.offset < window.pageYOffset) {
                scrollDirectionY = 1;
            } else if (this.data.scrollY.offset > window.pageYOffset) {
                scrollDirectionY = -1;
            }
        }

        this.set('online', navigator.onLine);
        this.set('doNotTrack', navigator.doNotTrack == '1' || window.doNotTrack == '1' || navigator.msDoNotTrack == '1');
        this.set('userAgent', navigator.userAgent);
        this.set('language', navigator.language);
        this.set('cookieEnabled', navigator.cookieEnabled);
        this.set('referrer', document.referrer);

        this.set('location', {
            hash: window.location.hash,
            host: window.location.host,
            hostname: window.location.hostname,
            href: window.location.href,
            origin: window.location.origin,
            pathname: window.location.pathname,
            port: window.location.port,
            protocol: window.location.protocol,
            search: window.location.search,
            pathparts: window.location.pathname.substr(1).split('/')
        });

        this.set('scrollX', {
            offset: window.pageXOffset,
            length: Math.max(0, docWidth - window.innerWidth),
            direction: scrollDirectionX,
            position: window.pageXOffset > 0 ? window.pageXOffset / (docWidth - window.innerWidth) : 0
        });

        this.set('scrollY', {
            offset: window.pageYOffset,
            length: Math.max(0, docHeight - window.innerHeight),
            direction: scrollDirectionY,
            position: window.pageYOffset > 0 ? window.pageYOffset / (docHeight - window.innerHeight) : 0
        });

        this.set('viewport', {
            width: window.innerWidth,
            height: window.innerHeight,
            scrollX: window.pageXOffset,
            scrollY: window.pageYOffset
        });

        this.set('device', {
            width: window.screen.width,
            height: window.screen.height,
            pixelRatio: window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI,
            orientation: this.getOrientation()
        });

        this.set('document', {
            width: docWidth,
            height: docHeight,
            hidden: document.hidden,
            visibility: document.visibilityState
        });

        if (event && event.type) {
            this.dispatchEvent(event);
        }
    },

    getOrientation: function() {
        if (window.matchMedia("(orientation: portrait)").matches) {
            return 'portrait';
        } else {
            return 'landscape';
        }
    }

});
